import { VerifyEmailContent } from '@/components/verify-email/VerifyEmailContent';
import { AxiosError } from 'axios';

type VerifyEmailProps = {
  email: string;
  onError: (error: AxiosError | undefined) => void;
  redirectUrl?: string;
};

export const VerifyEmail = ({ email, onError, redirectUrl }: VerifyEmailProps) => {
  return (
    <VerifyEmailContent email={email} redirectUrl={redirectUrl} onError={onError} autoSendInitialVerification={false} />
  );
};
